import React from "react";

import PaymentIcon from "./PaymentIcon";

import type { TFunction } from "i18next";

import type { PaymentKind } from "./paymentIcons.types";
import type { FilterOption } from "../../../dataTable/dataTable.types";

const PAYMENT_KIND_LIST: PaymentKind[] = [
  "okast",
  "stripe",
  "paypal",
  "apple",
  "google",
  "retailer",
];

export function paymentFilterOptions(
  t: TFunction,
  hasPaypalProvider: boolean,
): FilterOption[] {
  return PAYMENT_KIND_LIST.filter(
    (kind) => kind !== "paypal" || hasPaypalProvider,
  ).map((kind) => ({
    value: kind,
    label: t(kind),
    icon: <PaymentIcon kind={kind} />,
  }));
}
